import { useMutation } from '@tanstack/react-query'
import { deleteHelp } from '../index'

const useDeleteHelp = () =>
  useMutation({
    mutationFn: deleteHelp,
  })

export default useDeleteHelp
